import {
    FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_BEGIN,
    FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_ERROR,
    FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_SUCCESS
} from "../actions/promoter/promoterSalesPointActiveDevicesActions";
import {
    FETCH_PROMOTER_VIDEO_STATS_BEGIN,
    FETCH_PROMOTER_VIDEO_STATS_ERROR,
    FETCH_PROMOTER_VIDEO_STATS_SUCCESS
} from "../actions/promoter/promoterVideoStatsActions";
import {
    FETCH_PROMOTER_SALES_POINT_STATS_BEGIN,
    FETCH_PROMOTER_SALES_POINT_STATS_ERROR,
    FETCH_PROMOTER_SALES_POINT_STATS_SUCCESS
} from "../actions/promoter/promoterSalesPointStatsActions";

const defaultPromoterSalesPointStats = {
    promoterSalesPointStats: [],
    pagination: {},
    loading: false,
    error: null
}

const defaultPromoterSalesPointActiveDevices = {
    promoterSalesPointActiveDevices: [],
    pagination: {},
    loading: false,
    error: null
};

const defaultPromoterVideoStats = {
    promoterVideoStats: [],
    pagination: {},
    loading: false,
    error: null
}

export const promoterSalesPointStats = (state = defaultPromoterSalesPointStats, action) => {
    switch (action.type) {
        case FETCH_PROMOTER_SALES_POINT_STATS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PROMOTER_SALES_POINT_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                promoterSalesPointStats: action.payload.promoterSalesPointStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PROMOTER_SALES_POINT_STATS_ERROR:
            return {
                ...state,
                loading: false,
                promoterSalesPointStats: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

export const promoterSalesPointActiveDevices = (state = defaultPromoterSalesPointActiveDevices, action) => {
    switch (action.type) {
        case FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_SUCCESS:
            return {
                ...state,
                loading: false,
                promoterSalesPointActiveDevices: action.payload.promoterSalesPointActiveDevices,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PROMOTER_SALES_POINT_ACTIVE_DEVICES_ERROR:
            return {
                ...state,
                loading: false,
                promoterSalesPointActiveDevices: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

export const promoterVideoStats = (state = defaultPromoterVideoStats, action) => {
    switch (action.type) {
        case FETCH_PROMOTER_VIDEO_STATS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PROMOTER_VIDEO_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                promoterVideoStats: action.payload.promoterVideoStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PROMOTER_VIDEO_STATS_ERROR:
            return {
                ...state,
                loading: false,
                promoterVideoStats: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/promoterStats.js